<div>
  <div
    class="d-flex justify-content-between align-items-center globalborder-btm-header pb-2 px-3">
    <div class="d-flex justify-content-between align-items-center gap-3">
      <h2 class="mb-0">BC Revenue Transaction</h2>
    </div>

    <div class="d-flex align-items-center gap-3">
      <p-button
        label="Export Excel"
        variant="outlined"
        icon="pi pi-cloud-upload"
        severity="secondary"
        (click)="exportExcelFile()"
        class="fullwdth secondary-btn" />

      <p-button label=" Clear Filters" (click)="clearTable(dt)" />

      <span class="cross-border" (click)="onCloseModalEvent()"
        ><i class="pi pi-times"></i
      ></span>
    </div>
  </div>

  <div class="row adduser-container-hgt">
    <p-table
      #dt
      stripedRows
      scrollHeight="calc(100vh - 270px)"
      responsiveLayout="scroll"
      [value]="bcRevenueLists"
      [rowHover]="true"
      [rows]="20"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 50, 1000]"
      [paginator]="bcRevenueLists.length >= 20"
      [autoLayout]="true"
      [resizableColumns]="true"
      paginatorStyleClass="paginator-table-inside"
      styleClass="table-listing p-datatable-customers p-head-pad">
      <ng-template pTemplate="caption">
        <div class="d-flex align-items-center">
          <ng-container *ngIf="bcRevenueLists?.length">
            <div class="form-group has-float-label me-2 px-2">
              <label class="form-label" for="TotalBCRevenue"
                >Total BC Revenue</label
              >
              <input
                pInputText
                class="form-control filter me-2 text-end"
                type="text"
                [value]="TotalBCRevenue | number: '1.2-2'"
                disabled />
            </div>
            <div class="form-group has-float-label me-2">
              <label class="form-label" for="TotalBCGP">Total BC GP</label>
              <input
                pInputText
                class="form-control filter me-2 text-end"
                type="text"
                [value]="TotalBCGP | number: '1.2-2'"
                disabled />
            </div>
            <div class="form-group has-float-label me-2">
              <label class="form-label" for="BCAvgMargin"
                >BC Average Margin</label
              >
              <input
                pInputText
                class="form-control filter me-2 text-end"
                type="text"
                [value]="BCAvgMargin | number: '1.2-2'"
                disabled />
            </div>
            <div class="form-group has-float-label me-2">
              <label class="form-label" for="TotalBCCommission"
                >Total BC Commission</label
              >
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                [value]="TotalBCCommission | number: '1.2-2'"
                disabled
                class="form-control filter me-2 text-end" />
            </div>
            <div class="form-group has-float-label me-2">
              <label class="form-label" for="TotalBCReserve"
                >Total BC Reserve</label
              >
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                [value]="TotalBCReserve | number: '1.2-2'"
                disabled
                class="form-control filter me-2 text-end" />
            </div>
          </ng-container>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th pSortableColumn="ProjectName">
            Project name <p-sortIcon field="ProjectName"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="ProjectName"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="Date">
            Transaction date <p-sortIcon field="Date"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="Date"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="SalesOrderNumber">
            Sale order number <p-sortIcon field="SalesOrderNumber"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="SalesOrderNumber"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="InvoiceID">
            Invoice ID <p-sortIcon field="InvoiceID"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="InvoiceID"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="ClientName">
            Client name <p-sortIcon field="ClientName"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="ClientName"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="InvoiceTotal">
            Invoice total <p-sortIcon field="InvoiceTotal"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="InvoiceTotal"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="TotalSell">
            Total sell <p-sortIcon field="TotalSell"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="TotalSell"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="OrderCost">
            Order cost <p-sortIcon field="OrderCost"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="OrderCost"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="ServiceFee">
            Service fee <p-sortIcon field="ServiceFee"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="ServiceFee"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="TotalCost">
            Total cost <p-sortIcon field="TotalCost"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="TotalCost"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="GPAmount">
            GP amount <p-sortIcon field="GPAmount"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="GPAmount"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="Margin">
            Margin <p-sortIcon field="Margin"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="Margin"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="NetGPAmount">
            Net GP amount <p-sortIcon field="NetGPAmount"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="NetGPAmount"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="NetMargin">
            Net margin <p-sortIcon field="NetMargin"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="NetMargin"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="CommissionPercentage">
            Commission percentage
            <p-sortIcon field="CommissionPercentage"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="CommissionPercentage"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="BCRevenue">
            BC Revenue <p-sortIcon field="BCRevenue"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="BCRevenue"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="BCGP">
            BC GP <p-sortIcon field="BCGP"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="BCGP"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="BCCommission">
            BC Commission <p-sortIcon field="BCCommission"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="BCCommission"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="BCReserve">
            BC Reserve <p-sortIcon field="BCReserve"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="BCReserve"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="ExcludedFromCommissionLevelCalculation">
            Excluded from commission level calculation
            <p-sortIcon
              field="ExcludedFromCommissionLevelCalculation"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="ExcludedFromCommissionLevelCalculation"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="ExclusionApprovedBy">
            Exclusion approved by
            <p-sortIcon field="ExclusionApprovedBy"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="ExclusionApprovedBy"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="IsCommissionExcluded">
            Commission excluded
            <p-sortIcon field="IsCommissionExcluded"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="IsCommissionExcluded"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="IsChargeback">
            Is chargeback <p-sortIcon field="IsChargeback"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="IsChargeback"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="CommissionJournal">
            Commission journal
            <p-sortIcon field="CommissionJournal"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="CommissionJournal"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="OriginReference">
            OriginReference <p-sortIcon field="OriginReference"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="OriginReference"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="JNIInvoiceID">
            Invoice <p-sortIcon field="JNIInvoiceID"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="JNIInvoiceID"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="VendorName">
            Vendor name <p-sortIcon field="VendorName"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="VendorName"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="Description">
            Description <p-sortIcon field="Description"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="Description"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="CreatedDateTime">
            Created date and time
            <p-sortIcon field="CreatedDateTime"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="CreatedDateTime"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="CreatedBy">
            Created by <p-sortIcon field="CreatedBy"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="CreatedBy"
              display="menu"></p-columnFilter>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-bcRevenueList let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pSelectableRow]="bcRevenueList"
          [pSelectableRowIndex]="rowIndex">
          <td>{{ bcRevenueList.ProjectName }}</td>
          <td>
            <span *ngIf="bcRevenueList?.Date | hidedynamicsdate">
              {{ bcRevenueList.Date | date: "MM-dd-yyyy" }}
            </span>
          </td>
          <td class="number">
            <a
              class="link"
              (click)="redirectToSummary(bcRevenueList.SalesOrderNumber)">
              {{ bcRevenueList.SalesOrderNumber }}</a
            >
          </td>
          <td>
            <a
              class="link"
              (click)="redirectToInvoice(bcRevenueList.InvoiceID)">
              {{ bcRevenueList.InvoiceID }}</a
            >
          </td>
          <td>
            <a
              class="link"
              (click)="redirectToClientSummary(bcRevenueList.ClientId)">
              {{ bcRevenueList.ClientName }}</a
            >
          </td>
          <td class="align-right">
            {{ bcRevenueList.InvoiceTotal | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.TotalSell | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.OrderCost | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.ServiceFee | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.TotalCost | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.GPAmount | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.Margin | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.NetGPAmount | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.NetMargin | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.CommissionPercentage | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.BCRevenue | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.BCGP | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.BCCommission | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{ bcRevenueList.BCReserve | number: "1.2-2" }}
          </td>
          <td class="align-right">
            {{
              bcRevenueList.ExcludedFromCommissionLevelCalculation
                | number: "1.2-2"
            }}
          </td>
          <td>{{ bcRevenueList.ExclusionApprovedBy }}</td>
          <td>
            <input
              pInputText
              [checked]="bcRevenueList.IsCommissionExcluded"
              class="form-check-input"
              type="checkbox"
              disabled />
          </td>
          <td>
            <input
              pInputText
              [checked]="bcRevenueList.IsChargeback"
              class="form-check-input"
              type="checkbox"
              disabled />
          </td>
          <td>{{ bcRevenueList.CommissionJournal }}</td>
          <td>{{ bcRevenueList.OriginReference }}</td>
          <td>{{ bcRevenueList.JNIInvoiceID }}</td>
          <td>{{ bcRevenueList.VendorName }}</td>
          <td>{{ bcRevenueList.Description }}</td>
          <td>
            <span *ngIf="bcRevenueList?.CreatedDateTime | hidedynamicsdate">
              {{ bcRevenueList.CreatedDateTime | date: "MM-dd-yyyy" }}
            </span>
          </td>
          <td>{{ bcRevenueList.CreatedBy }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="30">No Data Found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="customerId"
      (closeModalOnRedirectionEvent)="closeModalOnRedirection()"
      (scrollHiddenStatus)="addScollHiddenClass()"
      [isModal]="true"
      (closeEvent)="closeModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
